import { Component, inject } from '@angular/core';

import { AppSessionService } from 'src/app/core/services/app-session/app-session.service';
import { Session } from 'src/app/core/models/session';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html'
})
export class ForbiddenComponent {

  private readonly _appSessionService: AppSessionService = inject(AppSessionService);

  /**
   * Get SystemUser logged in session.
   */
  public get session(): Session {
    return this._appSessionService.session!;
  }
}